import { FinancialInstitutionTypes } from '@models/lender';

export class Search {
	static readonly type = '[financialInstitutionSearch] search';
	constructor(
		public payload: {
			searchValue: string;
			filters: {
				[key in FinancialInstitutionTypes]?: boolean;
			};
			filterCS?: boolean;
		},
	) {}
}

export class Reset {
	static readonly type = '[financialInstitutionSearch] reset';
	constructor() {}
}
